import React from 'react';
import { connect } from "react-redux";
import { withSnackbar } from 'notistack';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import DataGrid, { Button, Column, SearchPanel, Export, ColumnChooser, ColumnFixing, HeaderFilter, Summary, Scrolling, Toolbar, Item as ToolbarItem, FilterPanel } from 'devextreme-react/data-grid';
import { FormattedMessage, injectIntl } from "react-intl";
import moment from 'moment';
import * as companiesCrud from '../../../../crud/companies.crud';
import * as migrationCrud from '../../../../crud/migration.crud';
import { withRouter } from '../../../../shared/hoc/withRouter';
import MigrationCreateModal, { RESPONSES as CreateModalResponses } from './MigrationCreateModal';
import { getMigrationProcessStatus } from '../../../../shared/lookup';
import DefaultWorkflows from '../../../../Templates/DefaultWorkflows';
import Common from '../../../../shared/common';
import MigrationErrorLogDetails from './MigrationErrorLogDetails';
import { custom as CustomDialog } from 'devextreme/ui/dialog';
import SystemHelper from "../../../../shared/systemHelper";

class Migration extends React.Component {
  constructor(props) {
    super(props);
    this.wfDataSource = DefaultWorkflows.reduce((wfArray, wfg) => {
      if (wfg.workflows.length > 0) {
        wfArray.push(
          ...wfg.workflows.map(wf => ({
            value: wf.id,
            display: `[${Common.Lpad(wf.id, 2)}] ${wf.config.description}`,
          }))
        );
      }
      return wfArray;
    }, []);
    this.migrationProcessStatuses = getMigrationProcessStatus(this.props.intl);
    this.state = {
      isBusy: true,
      migrationData: null,
      showAddMigrationModal: false,
      companiesDataSource: null,
      seletedItemDetails: null
    }
  }

  componentDidMount() {
    this.loadMigrations();
    this.loadCompaniesDataSource();
    this.setRefreshTimer();
  }
  componentWillUnmount() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  }
  setRefreshTimer = () => {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
    this.timerId = setInterval(() => {
      if (!this.state.isBusy && !this.state.showAddMigrationModal && !this.state.seletedItemDetails) {
        this.loadMigrations();
      }
    }, (20 * 1000));
  }

  loadMigrations = () => {
    this.setState({ isBusy: true }, async () => {
      try {
        const { data: migrationData } = await migrationCrud.getRegisterList();
        this.setState({ migrationData, isBusy: false });
      }
      catch (err) {
        this.setState({ migrationData: null, isBusy: false });
        this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
      }
    });
  }

  importExcelClicked = () => {
    this.setState({ showAddMigrationModal: true });
  }
  importExcelDialogResult = (result) => {
    this.setState({ showAddMigrationModal: false }, () => {
      if (result === CreateModalResponses.SAVE) {
        this.props.enqueueSnackbar("Migration file successfully uploaded", { variant: 'success', });
        this.loadMigrations();
      }
    });
  }
  loadCompaniesDataSource = async () => {
    try {
      const { data: companiesOpts } = await companiesCrud.getCutDownCompaniesList();
      this.setState({ companiesDataSource: companiesOpts });
    } catch (err) {
      this.setState({ companiesDataSource: null });
      this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
    }

  }
  onRowPrepared = (e) => {
    if (e.rowType === "data" && e.rowElement) {
      if (e.data?.processstatus === 2) {
        e.rowElement.style.backgroundColor = '#E9EAEC';
      }
      else if (e.data?.processstatus === 3) {
        e.rowElement.style.backgroundColor = '#DFFFE9';
      }
      else if (e.data?.processstatus === 4) {
        e.rowElement.style.backgroundColor = '#ffcccb';
      }

    }
  }
  isViewErrorLogsVisible = (e) => {
    return e.row.data.failcount > 0;
  }
  isRestartVisible = (e) => {
    return this.props.userProfile.accounttype === "System Owner" && [1, 2, 4].includes(e.row.data.processstatus);
  }
  restartClick = async (e) => {
    try {
      const selectedItem = { ...e.row.data };


      let activateDialog = CustomDialog({
        title: "Restart Processing?",
        messageHtml: `<div style="max-width:60vw;">Please be sure worker thread is no longer working! Restarting working thread will continue processing remaining row data where previous thread left off. This may be dangereous if the process is still running.<br/><br/>"Force Restart" option will skip Thread-ID checks. Are you sure Restart the process the process?</div>`,
        buttons: [
          {
            text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CANCEL" }),
            onClick: (e) => { return "CANCEL" }
          },
          {
            text: "Restart",
            type: "danger",
            stylingMode: "outlined",
            onClick: (e) => { return "CONTINUE" }
          },
          {
            text: "Force Restart",
            type: "danger",
            stylingMode: "outlined",
            onClick: (e) => { return "CONTINUE_FORCE" }
          }

        ]
      });
      const result = await activateDialog.show();
      if (result.startsWith("CONTINUE")) {
        const forceRestart = result ==="CONTINUE_FORCE";
        await migrationCrud.restart(selectedItem.migrationid,forceRestart);
        this.loadMigrations();
      }


    } catch (err) {
      this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
    }
  }
  viewChangeLogClick = async (e) => {
    const clonedItem = { ...e.row.data };
    this.setState({ seletedItemDetails: clonedItem })

  }
  render() {
    return (
      <Portlet isLoading={this.state.isBusy} loadingDelay={0}>
        <PortletBody>
          <DataGrid
            ref={this.gridRef}
            height={'67vh'}
            dataSource={this.state.migrationData}
            hoverStateEnabled={true}
            rowAlternationEnabled={false}
            showBorders={true}
            showColumnLines={true}
            showRowLines={true}
            remoteOperations={false}
            allowColumnResizing={true}
            allowColumnReordering={true}
            columnResizingMode='widget'
            onRowRemoving={this.onRowRemoving}
            style={{ width: '100%', height: '100%', maxHeight: '67vh' }}
            name="Migrations"
            keyExpr="migrationid"
            onSelectionChanged={this.onSelectionChanged}
            onExporting={this.onExporting}
            loadPanel={{ enabled: false }}
            onInitialized={this.onDatagridInitialized}
            onRowPrepared={this.onRowPrepared}
          >


            <HeaderFilter visible={true} />
            <FilterPanel visible={true} />
            <ColumnChooser enabled={true} />
            <ColumnFixing enabled={true} />


            <Export enabled={true} fileName={"Migrations"} />
            <SearchPanel visible={true} highlightCaseSensitive={false} defaultText="" />



            <Column
              caption="Company"
              dataField="companyid"
              lookup={{
                dataSource: this.state.companiesDataSource,
                valueExpr: 'companyid',
                displayExpr: 'name'
              }}
            />
            <Column
              caption="Master Template"
              dataField="templatename"
            />
            <Column
              caption="Master Template ID"
              dataField="mastertemplateid"
              visible={false}
            />
            <Column
              caption="Workflow"
              dataField="workflowid"
              lookup={{
                dataSource: this.wfDataSource,
                valueExpr: 'value',
                displayExpr: 'display'
              }}
            />
            <Column
              caption={"Description"}
              dataField="description"
              visible={false}
            />

            <Column
              caption="Row Count"
              dataField="recordcount"
            />
            <Column
              caption="Status"
              dataField="processstatus"
              lookup={{
                dataSource: this.migrationProcessStatuses,
                valueExpr: 'value',
                displayExpr: 'display'
              }}
            />
            <Column
              caption={"Start Date"}
              dataField="processstartdate"
              dataType="date"
              format={(date) => moment(date).format('DD/MM/YYYY HH:mm')}
            />
            <Column
              caption={"End Date"}
              dataField="processenddate"
              dataType="date"
              format={(date) => moment(date).format('DD/MM/YYYY HH:mm')}
            />
            <Column
              caption="Successful Record Count"
              dataField="successcount"
            />
            <Column
              caption="Failed Record Count"
              dataField="failcount"
            />
            <Column
              caption={"Error"}
              dataField="error"
              visible={false}
            />
            <Column caption='Restart' name="restartButton" type="buttons" >
              <Button
                name="Restart"
                hint="Restart process"
                icon="refresh"
                visible={this.isRestartVisible}
                disabled={false}
                onClick={this.restartClick}
              />
            </Column>
            <Column caption='Row Errors' name="viewErrorsButton" type="buttons" >
              <Button
                name="ViewErrorLog"
                hint="View Error Logs"
                icon="bulletlist"
                visible={this.isViewErrorLogsVisible}
                disabled={false}
                onClick={this.viewChangeLogClick}
              />
            </Column>
            <Scrolling mode="virtual" showScrollbar={true} useNative={true} columnRenderingMode="virtual" rowRenderingMode="virtual" />
            <Toolbar>
              <ToolbarItem location="before">
                <div>
                  <h3 style={{ fontFamily: SystemHelper.getThemeTextFont(), fontSize: '1.2rem', fontWeight: 500, color: '#48465b', padding: 0, margin: 0, lineHeight: 1.2 }} className="kt-portlet__head-title">
                    {/* <FormattedMessage id='ACTIONS.TITLE' /> */}
                    Migration Files
                  </h3>
                </div>
              </ToolbarItem>

              <ToolbarItem
                location="after"
                locateInMenu="auto"
                widget="dxButton"
                options={{
                  icon: "import",
                  text: "Upload Migration File",
                  onClick: this.importExcelClicked,
                }}
              />
              <ToolbarItem
                location="after"
                locateInMenu="auto"
                widget="dxButton"
                options={{
                  icon: "refresh",
                  text: this.props.intl.formatMessage({ id: "GENERAL.BUTTON.REFRESH" }),
                  onClick: this.loadMigrations,
                }}
              />


              <ToolbarItem location="after"
                locateInMenu="auto"
                name="applyFilterButton"
              />
              <ToolbarItem location="after"
                locateInMenu="auto"
                name="columnChooserButton"
              />
              <ToolbarItem location="after"
                locateInMenu="auto"
                name="searchPanel"
              />
            </Toolbar>
            <Summary
              calculateCustomSummary={this.calculateSelectedRowSummary}
              recalculateWhileEditing={true}
            >
            </Summary>
          </DataGrid>
          <MigrationCreateModal
            visible={this.state.showAddMigrationModal}
            allowRecurrent={true}
            onDialogResult={this.importExcelDialogResult}
          />
          <MigrationErrorLogDetails
            migrationItem={this.state.seletedItemDetails}
            onClose={() => { this.setState({ seletedItemDetails: null }) }}
          />
        </PortletBody>
      </Portlet>
    );
  }
}


const mapStateToProps = store => ({
  // contract: store.contract.contract,
  // contractTemplate: store.contract.template,
  userProfile: store.auth.userProfile
});

export default injectIntl(withRouter(withSnackbar(connect(mapStateToProps)(Migration))));
